export function Timer(max = 6000) {
  this.currentTime = 0;

  let intervalHandler = null;
  let timeoutHandler = null;

  let eventHandlers = {};

  // it will return the formated time  --> Hr,Min,Sec

  function runHandlers(event, values) {
    if (eventHandlers[event]) {
      eventHandlers[event].forEach((callback) => {
        callback(values);
      });
    }
  }

  this.start = () => {
    this.reset();
    this.currentTime = 0;
    intervalHandler = setInterval(() => {
      this.currentTime += 100;
      runHandlers("update", this.currentTime);
    }, 100);
    timeoutHandler = setTimeout(() => {
      this.reset();
      runHandlers("stop", true);
    }, max);
    runHandlers("start");
  };

  this.pause = () => {
    clearInterval(intervalHandler);
    clearTimeout(timeoutHandler);
    runHandlers("pause");
  };

  this.resume = () => {
    intervalHandler = setInterval(() => {
      this.currentTime += 100;
      runHandlers("update", this.currentTime);
    }, 100);
    timeoutHandler = setTimeout(() => {
      this.reset();
      runHandlers("stop", true);
    }, max - this.currentTime);
    runHandlers("resume");
  };

  this.stop = () => {
    this.reset();
    runHandlers("stop");
    return this.currentTime;
  };

  this.reset = () => {
    clearInterval(intervalHandler);
    clearTimeout(timeoutHandler);
  };

  this.on = (event, callback) => {
    eventHandlers[event] = eventHandlers[event] || [];
    eventHandlers[event].push(callback);
  };
}

export function formatTimer(time, showHours) {
  let secNum = Math.round(time / 1000);
  let hours = Math.floor(secNum / 3600);
  let minutes = Math.floor((secNum - hours * 3600) / 60);
  let seconds = secNum - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  if (showHours) {
    return hours + ":" + minutes + ":" + seconds;
  } else {
    return minutes + ":" + seconds;
  }
}
